document.addEventListener('DOMContentLoaded', () => {

    const cards = document.querySelectorAll('.wear-card');
    const lightbox = document.getElementById('WearLightbox');

    if (!lightbox) return;

    const image = lightbox.querySelector('.wear-lightbox__image');
    const closeBtn = lightbox.querySelector('.wear-lightbox__close');
    const overlay = lightbox.querySelector('.wear-lightbox__overlay');

    function openLightbox(src, alt = '') {

        image.src = src;
        image.alt = alt;

        lightbox.classList.add('active');
        lightbox.setAttribute('aria-hidden', 'false');

        document.body.classList.add('wear-lock');
    }

    function closeLightbox() {

        lightbox.classList.remove('active');
        lightbox.setAttribute('aria-hidden', 'true');

        document.body.classList.remove('wear-lock');

        setTimeout(() => {

            image.src = '';

        }, 300);

    }

    cards.forEach(card => {
        const slider = document.querySelector('.wear-editorial__grid');
const dots = document.querySelectorAll('.wear-dot');

if(slider && window.innerWidth < 750){

slider.addEventListener('scroll',()=>{

const cardWidth = slider.querySelector('.wear-card').offsetWidth + 16;

const index = Math.round(slider.scrollLeft/cardWidth);

dots.forEach((dot,i)=>{

dot.classList.toggle('active',i===index);

});

});

dots.forEach((dot,i)=>{

dot.addEventListener('click',()=>{

const cardWidth = slider.querySelector('.wear-card').offsetWidth + 16;

slider.scrollTo({

left:cardWidth*i,

behavior:'smooth'

});

});

});

}

        card.addEventListener('click', () => {

            const src = card.dataset.image;
            const alt = card.querySelector('h3')?.innerText || '';

            openLightbox(src, alt);

        });

    });

    closeBtn.addEventListener('click', closeLightbox);

    overlay.addEventListener('click', closeLightbox);

    document.addEventListener('keydown', (e) => {

        if (e.key === 'Escape') {

            closeLightbox();

        }

    });

});